export const ENTORNO = 'produccionCasportHTTPS';

const localMoviport = {
    url: '//localhost',
    port: '3001',
    realTimeServerUrl: '//localhost',
    realTimeServerPort: '3001'
}

const localCasport = {
    url: '//localhost',
    port: '3001',
    realTimeServerUrl: '//localhost',
    realTimeServerPort: '3001'
}

const produccionMoviport = {
    url: 'http://35.164.204.254',
    port: '3000',
    realTimeServerUrl: 'http://35.164.204.254',
    realTimeServerPort: '3000'
}

const produccionMoviportHTTPS = {
    url: 'https://provisiones.moviportsa.com.ar',
    realTimeServerUrl: 'https://provisiones.moviportsa.com.ar'
}

const produccionCasport = {
    url: 'http://52.34.117.128',
    port: '3000',
    realTimeServerUrl: 'http://52.34.117.128',
    realTimeServerPort: '3000'
}

const produccionCasportHTTPS = {
    url: 'https://provisiones.casport.com.ar',
    realTimeServerUrl: 'https://provisiones.casport.com.ar'
}



export function getRealTimeServerURL() {

    switch (ENTORNO) {
        case 'localMoviport':
            return `${localMoviport.realTimeServerUrl}:${localMoviport.realTimeServerPort}`;
            break;
        case 'localCasport':
            return `${localCasport.realTimeServerUrl}:${localCasport.realTimeServerPort}`;
            break;
        case 'produccionMoviport':
            return `${produccionMoviport.realTimeServerUrl}:${produccionMoviport.realTimeServerPort}`;
            break;
        case 'produccionMoviportHTTPS':
            return `${produccionMoviportHTTPS.realTimeServerUrl}`;
            break;
        case 'produccionCasport':
            return `${produccionCasport.realTimeServerUrl}:${produccionCasport.realTimeServerPort}`;
            break;
        case 'produccionCasportHTTPS':
            return `${produccionCasportHTTPS.realTimeServerUrl}`;
            break;
    }
}

export function getServerURL() {

    switch (ENTORNO) {
        case 'localMoviport':
            return `${localMoviport.url}:${localMoviport.port}/api`;
            break;
        case 'localCasport':
            return `${localCasport.url}:${localCasport.port}/api`;
            break;
        case 'produccionMoviport':
            return `${produccionMoviport.url}:${produccionMoviport.port}/api/`;
            break;
        case 'produccionMoviportHTTPS':
            return `${produccionMoviportHTTPS.url}/api/`;
            break;
        case 'produccionCasport':
            return `${produccionCasport.url}:${produccionCasport.port}/api/`;
            break;
        case 'produccionCasportHTTPS':
            return `${produccionCasportHTTPS.url}/api/`;
            break;
    }
}